import React, { useEffect, useState, useRef } from 'react';
import { mfaOtpStyles } from './mfaOtpStyles';
import {
    TextField,
    Grid,
    CircularProgress,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    useTheme,
} from '@material-ui/core';
import MyEirLoginHeader from './MyEirLoginHeader';
import MyEirLoginFooter from './MyEirLoginFooter';
import { Typography } from '@material-ui/core';
import { Box } from '@material-ui/core';
import phoneIcon from '../images/phone_icon.svg';
import { usePhoneNumber } from '../../sharedcomponents/css/usePhoneNumber';
import SuccessPopup from './SuccessPopup';
import EirButton from '../../theme/EirButton';
import AlertOfForgotPassword from './AlertOfForgotPassword';
import { useWindowDimension } from '../../hooks/windowDimensions';
import ENDPOINTS from '../../components/graphql/GraphQLConstants';
import { useApolloClient } from '@apollo/client';

const MFAContactNumScreen = props => {
    const graphql = useApolloClient();
    const theme = useTheme();
    const [code, setCode] = useState('');
    const services = props?.loginOperation?.data?.login?.services || [];
    const mobileServices = services?.filter(service => service?.type?.toUpperCase() === 'MOBILE');
    // const services = [
    //     {
    //         number: '0851234567',
    //         type: 'FIBRE',
    //     },
    //     {
    //         number: '0851234561',
    //         type: 'TV',
    //     },
    //     {
    //         number: '0851234560',
    //         type: 'TV',
    //     },
    // ];
    const [singleServices, setSingleServices] = useState(false);
    const [openList, setOpenList] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [width, height] = useWindowDimension();
    const classes = usePhoneNumber();
    const [activeCode, setActiveCode] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(false);
    const useStyle = mfaOtpStyles({ activeCode });
    const [invalidPhone, setInvalidPhone] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showLabelPhone, setShowLabelPhone] = useState(false);
    const [areaCodeOption, setAreaCodeOption] = useState([]);

    const [phoneNum, setPhoneNum] = React.useState({
        value: null,
        displayNumber: '',
        pattern: /^[0-9]*$/,
        error: { value: false, message: 'Please enter a valid number' },
    });
    async function areaCodeOptions() {
        try {
            const { data: allAreaCodes } = await graphql.query({
                query: ENDPOINTS.AREA_CODES,
            });

            if (allAreaCodes !== null) {
                // console.log("area codes:", response.data.areaCodes)
                setAreaCodeOption(allAreaCodes.areaCodes);
            } else {
                console.log('area codes are null values!!');
                setAreaCodeOption([]);
                // setPhoneNum({error: { value: true, message: 'Something went wrong!' }})
            }
        } catch (error) {
            console.log('area codes error:', error);
            setAreaCodeOption([]);
            // setPhoneNum({error: { value: true, message: 'Something went wrong!' }})
        }
    }
    const handleCodeChange = event => {
        setOpenList(false);
        setCode(event.target.value);
        props.setSelectedContact(event.target.value);
        // setFormSuccess({ ...formSuccess, isCodeNumber: true, isPhoneNumber: Boolean(phoneNum) });
        if (Boolean(phoneNum)) {
            setPhoneNum({
                ...phoneNum,
                error: { value: false, message: '' },
            });
            setEnableSubmit(true);
        }
        setInvalidPhone(!Boolean(phoneNum));
    };

    const handleLabelPhoneNum = val => {
        setShowLabelPhone(val);
    };
    const handlePrefixChange = event => {
        setOpenList(false);
        setCode(event.target.value);
        // setFormSuccess({ ...formSuccess, isCodeNumber: true, isPhoneNumber: Boolean(phoneNum) });
        if (Boolean(phoneNum)) {
            setPhoneNum({
                ...phoneNum,
                error: { value: false, message: '' },
            });
            // setEnableSubmit(true);
        }
        setInvalidPhone(!Boolean(phoneNum));
    };
    const handlePhoneNumber = event => {
        // console.log(event.target.value, /^[0-9]*$/.test(event.target.value), phoneNum);
        if (/^[0-9]*$/.test(event.target.value)) {
            setPhoneNum({
                ...phoneNum,
                value: event.target.value,
                displayNumber: event.target.value,
            });

            let val = `${code}${event.target.value}`;

            props.setSelectedContact(val);
            setInvalidPhone(false);

            if (event.target.value.length < 5) {
                setPhoneNum({
                    ...phoneNum,
                    value: event.target.value,
                    displayNumber: event.target.value,
                    error: { value: true, message: 'Please enter a valid number' },
                });

                setInvalidPhone(true);
            } else {
                setPhoneNum({
                    ...phoneNum,
                    value: event.target.value,
                    displayNumber: event.target.value,
                    error: { value: false, message: '' },
                });
                props.setSelectedContact(val);
                setInvalidPhone(false);
                setEnableSubmit(true);
            }
        } else {
            // console.log('Invalid number');
            setPhoneNum({
                ...phoneNum,
                error: { value: true, message: 'Please enter a valid number' },
            });
        }
    };

    const handleContactNumber = async () => {
        if (singleServices) {
            props.setSelectedContact(mobileServices?.[0]?.number);
        }

        props.setLoginScreen(3);
    };
    const handleBackButton = () => {
        props.handleBackButton(2);
    };

    useEffect(() => {
        setSingleServices(mobileServices.length === 1);
        setIsMobile(mobileServices.length > 0);
    }, [services]);
    useEffect(() => {
        areaCodeOptions();
    }, []);

    return (
        <>
            <div className={useStyle.otpContainer}>
                <div className={useStyle.otpcardContainerMFA}>
                    <MyEirLoginHeader
                        headerText='Secure your account'
                        loginScreen={props.loginScreen + 1}
                        handleBackButton={handleBackButton}
                    />

                    {/* body part */}
                    <div className={`${useStyle.bodyMFA} verification-body`}>
                        <Grid container>
                            <Grid item xs={12}>
                                <div
                                    className={useStyle.text}
                                    style={
                                        width < 600
                                            ? {
                                                  minHeight: '46px',
                                                  marginTop: '6px',
                                                  marginBottom: '24px',
                                              }
                                            : {}
                                    }
                                >
                                    {isMobile ? (
                                        singleServices ? (
                                            <Typography className={useStyle.contactText}>
                                                Important. Please confirm the mobile number you
                                                would like us to send your verification codes to.
                                            </Typography>
                                        ) : (
                                            <Typography className={useStyle.contactText}>
                                                Important. Please select the mobile number you would
                                                like us to send your verification codes to.
                                            </Typography>
                                        )
                                    ) : (
                                        <Typography className={useStyle.contactText}>
                                            Enter a valid Irish mobile number to receive your
                                            verification codes.{' '}
                                        </Typography>
                                    )}
                                    {isMobile ? (
                                        <>
                                            {singleServices ? (
                                                <Box
                                                    className={useStyle.contact}
                                                    style={{ display: 'flex' }}
                                                >
                                                    <Box
                                                        component='img'
                                                        src={phoneIcon}
                                                        alt=''
                                                        className={useStyle.phoneIcon}
                                                    />
                                                    <Typography className={useStyle.contactNum}>
                                                        {/* 085 123 4567 */}
                                                        {mobileServices?.[0]?.number}
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <FormControl
                                                    variant='outlined'
                                                    className={classes.formControl}
                                                    style={width < 599 ? { width: '256px' } : {}}
                                                >
                                                    <InputLabel
                                                        style={{
                                                            ...(invalidPhone
                                                                ? {
                                                                      color:
                                                                          theme.palette.primary
                                                                              .error,
                                                                  }
                                                                : {}),
                                                            ...(openList || code
                                                                ? { fontSize: '14px' }
                                                                : { fontSize: '16px' }),
                                                        }}
                                                    >
                                                        Phone number
                                                    </InputLabel>
                                                    <Select
                                                        labelId='select'
                                                        id='code-select'
                                                        value={code}
                                                        onChange={handleCodeChange}
                                                        open={openList}
                                                        onOpen={() => setOpenList(true)}
                                                        onClose={() => setOpenList(false)}
                                                        label='Phone number'
                                                        error={invalidPhone}
                                                        //variant="outlined"
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: 'bottom',
                                                                horizontal: 'left',
                                                            },
                                                            transformOrigin: {
                                                                vertical: 'top',
                                                                horizontal: 'left',
                                                            },
                                                            // getContentAnchorEl: null,
                                                            disablePortal: false,

                                                            PaperProps: {
                                                                style: {
                                                                    marginTop: 63,
                                                                },
                                                            },
                                                        }}
                                                    >
                                                        {mobileServices?.map((service, index) => (
                                                            <MenuItem
                                                                key={index}
                                                                value={service.number}
                                                            >
                                                                {service.number.replace(
                                                                    /(\d{3})(\d{3})(\d{4})/,
                                                                    '$1 $2 $3'
                                                                )}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </>
                                    ) : (
                                        <div
                                            className={classes.enterPhoneBody}
                                            style={
                                                width < 600
                                                    ? {
                                                          width: '256px',
                                                          height: '58px',
                                                          minHeight: '58px',
                                                          marginTop: '24px',
                                                          padding: 0,
                                                      }
                                                    : {
                                                          width: '387px',
                                                          height: '75px',
                                                          minHeight: '75px',
                                                          padding: 0,
                                                      }
                                            }
                                        >
                                            <Grid
                                                container
                                                spacing={0}
                                                className={classes.phoneCodeGrid}
                                                style={width < 600 ? {} : { margin: 0 }}
                                            >
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    className='register-grid-text-information'
                                                    // style={{ display: 'flex' }}
                                                    style={
                                                        phoneNum.error.value
                                                            ? {
                                                                  marginBottom: '0px',
                                                                  display: 'flex',
                                                              }
                                                            : { display: 'flex' }
                                                    }
                                                >
                                                    <Grid
                                                        item
                                                        sm={2}
                                                        xs={5}
                                                        md={3}
                                                        className={classes.codeNumber}
                                                    >
                                                        <FormControl
                                                            variant='outlined'
                                                            className={classes.formControl}
                                                        >
                                                            <InputLabel
                                                                style={
                                                                    invalidPhone
                                                                        ? {
                                                                              color:
                                                                                  theme.palette
                                                                                      .primary
                                                                                      .error,
                                                                          }
                                                                        : {}
                                                                }
                                                            >
                                                                Prefix
                                                            </InputLabel>
                                                            <Select
                                                                labelId='select'
                                                                id='code-select'
                                                                value={code}
                                                                onChange={handlePrefixChange}
                                                                open={openList}
                                                                onOpen={() => setOpenList(true)}
                                                                onClose={() => setOpenList(false)}
                                                                label='Prefix'
                                                                error={invalidPhone}
                                                                //variant="outlined"
                                                                MenuProps={{
                                                                    anchorOrigin: {
                                                                        vertical: 'bottom',
                                                                        horizontal: 'left',
                                                                    },
                                                                    transformOrigin: {
                                                                        vertical: 'top',
                                                                        horizontal: 'left',
                                                                    },
                                                                    // getContentAnchorEl: null,
                                                                    disablePortal: false,
                                                                }}
                                                                style={
                                                                    width < 600
                                                                        ? {}
                                                                        : { marginRight: '8px' }
                                                                }
                                                            >
                                                                {areaCodeOption.map(
                                                                    ({ AREA_CODE, index }) => (
                                                                        <MenuItem value={AREA_CODE}>
                                                                            {AREA_CODE}
                                                                        </MenuItem>
                                                                    )
                                                                )}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid
                                                        item
                                                        sm={4}
                                                        xs={7}
                                                        md={9}
                                                        className={classes.phoneNumber}
                                                    >
                                                        <TextField
                                                            className={`${classes.textField} ${classes.textFieldNumberInput}`}
                                                            //error={phoneNum.error.value}
                                                            type='number'
                                                            label='Phone number'
                                                            //label={showLabelPhone ? 'Phone number' : 'Your phone number'}
                                                            variant='outlined'
                                                            value={phoneNum.displayNumber}
                                                            onChange={handlePhoneNumber}
                                                            error={invalidPhone}
                                                            inputProps={{
                                                                maxLength: 7,
                                                                // pattern: /^[0-9]*$/,
                                                            }}
                                                            onFocus={() => {
                                                                handleLabelPhoneNum(true);
                                                            }}
                                                            onBlur={() => {
                                                                handleLabelPhoneNum(false);
                                                            }}
                                                        ></TextField>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} className={classes.errormessage}>
                                                    {phoneNum.error.value ? (
                                                        <div className='invalid-messages'>
                                                            {phoneNum.error.message}
                                                        </div>
                                                    ) : (
                                                        ' '
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )}

                                    <div
                                        className={useStyle.notice}
                                        style={
                                            phoneNum.error.value && width < 600
                                                ? { marginTop: '35px' }
                                                : {}
                                        }
                                    >
                                        <AlertOfForgotPassword email='' flag='mfa' />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={useStyle.footer}>
                        {!isLoading ? (
                            <MyEirLoginFooter
                                ariaLabel1='Continue to next step'
                                button1Text='Confirm & continue'
                                handleButton1Click={handleContactNumber}
                                button1Enabled={
                                    singleServices
                                        ? true
                                        : !invalidPhone && enableSubmit
                                        ? enableSubmit
                                        : false
                                }
                            />
                        ) : (
                            <EirButton
                                variants='primaryButtonMedium'
                                style={{ padding: '0.5rem 2.5rem' }}
                                // className={classes.paymentContent}
                            >
                                <CircularProgress
                                    disableShrink
                                    style={{
                                        color: 'white',
                                        width: '17px',
                                        height: '17px',
                                        marginRight: '5px',
                                    }}
                                />
                                Continuing...
                            </EirButton>
                        )}
                    </div>
                    {/* {showSuccess ? (
                        <SuccessPopup
                            open={showSuccess}
                            setOpen={setShowSuccess}
                            headText='Verified'
                            text='Your contact has been updated.'
                            flag='contact'
                        />
                    ) : (
                        ''
                    )}

                    {showError ? (
                        <SuccessPopup
                            open={showError}
                            setOpen={setShowError}
                            headText='Verification failed'
                            text='Sorry, we’re having some technical issues, please try again later.'
                            flag='contact'
                        />
                    ) : (
                        ''
                    )} */}
                </div>
            </div>
        </>
    );
};

export default MFAContactNumScreen;
